import React, { useState, useEffect } from 'react';
import { Switch } from 'antd';

import './components.scss';

const RequirementForTSAs = ({ options, changeAnswerValue, answer }) => {
  const [active, setActive] = useState(false);

  useEffect(() => {
    if (answer === '1') {
      setActive(false);
    } else {
      setActive(true);
    }
  }, [answer]);
  const onChange = (v) => {
    // setActive(v);
    setActive(v);
    const value = v ? '2' : '1';
    changeAnswerValue(value);
  };
  return (
    <div className="complexity-switch">
      <span className={!active ? 'switch-text-active' : ''}>
        {options.radioText ? options.radioText[0].text : options[0].text}
      </span>
      <Switch
        // defaultChecked
        checked={active}
        onChange={onChange}
        className="requirement-for-TSAs"
      />
      <span className={active ? 'switch-text-active' : ''}>
        {' '}
        {options.radioText ? options.radioText[1].text : options[1].text}
      </span>
    </div>
  );
};

export default RequirementForTSAs;
